import React, { useEffect, useState } from 'react';
import { useClientPortal } from '../../../context/ClientPortalContext';
import { PortalProfileService } from '../../../services/portal/portalProfileService';

const ProfileOverview = () => {
    const { client, clientId, refreshClient } = useClientPortal();
    const [formState, setFormState] = useState({ first_name: '', last_name: '', phone: '', preferred_language: 'en' });
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        if (client) {
            setFormState({
                first_name: client.first_name || '',
                last_name: client.last_name || '',
                phone: client.primary_phone || '',
                preferred_language: client.preferred_language || 'en'
            });
        }
    }, [client]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormState((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!clientId) return;
        setSaving(true);
        setMessage(null);
        const { error } = await PortalProfileService.updateClientProfile(clientId, {
            first_name: formState.first_name,
            last_name: formState.last_name,
            phone: formState.phone,
            preferred_language: formState.preferred_language
        });
        setSaving(false);
        if (error) {
            setMessage({ type: 'error', text: error.message || 'Failed to update profile' });
            return;
        }
        setMessage({ type: 'success', text: 'Profile updated' });
        refreshClient();
    };

    return (
        <div className="space-y-6">
            <section className="bg-white border border-slate-200 rounded-2xl p-6">
                <h3 className="text-lg font-semibold text-slate-900">Personal Details</h3>
                <p className="text-sm text-slate-500">Update your personal details. Changes sync instantly with your consultant.</p>
                <form className="mt-6 grid gap-4 sm:grid-cols-2" onSubmit={handleSubmit}>
                    <label className="block text-sm font-medium text-slate-700">
                        First name
                        <input
                            type="text"
                            name="first_name"
                            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                            value={formState.first_name}
                            onChange={handleChange}
                        />
                    </label>
                    <label className="block text-sm font-medium text-slate-700">
                        Last name
                        <input
                            type="text"
                            name="last_name"
                            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                            value={formState.last_name}
                            onChange={handleChange}
                        />
                    </label>
                    <label className="block text-sm font-medium text-slate-700">
                        Phone
                        <input
                            type="tel"
                            name="phone"
                            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                            value={formState.phone}
                            onChange={handleChange}
                        />
                    </label>
                    <label className="block text-sm font-medium text-slate-700">
                        Preferred language
                        <select
                            name="preferred_language"
                            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                            value={formState.preferred_language}
                            onChange={handleChange}
                        >
                            <option value="en">English</option>
                            <option value="de">German</option>
                            <option value="si">Sinhala</option>
                            <option value="ta">Tamil</option>
                        </select>
                    </label>

                    <div className="sm:col-span-2 flex items-center justify-between pt-2">
                        {message && (
                            <p className={`text-sm ${message.type === 'success' ? 'text-emerald-600' : 'text-rose-600'}`}>
                                {message.text}
                            </p>
                        )}
                        <button type="submit" className="btn-modern btn-primary ml-auto" disabled={saving}>
                            {saving ? 'Saving…' : 'Save changes'}
                        </button>
                    </div>
                </form>
            </section>
            {/* Additional sections for Address and Contact can be added here later */}
        </div>
    );
};

export default ProfileOverview;
